import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import {Edit as EditIcon} from '@mui/icons-material'
import clsx from 'clsx'
import Avatar from '../Avatar/Avatar'







const EditableAvatar = (props) => {
  const {onClick, picture, className} = props
  return (
    _jsxs('div', { className: "relative cursor-pointer" , onClick: onClick, 'aria-label': "click to update photo"   , children: [
      _jsx(Avatar, {
        picture: picture,
        className: clsx(`h-16 w-16 border-4 border-solid border-slate-200`, className),}
      )
      , _jsx('div', { className: "absolute top-0 left-0 flex h-full w-full items-center justify-center rounded-full bg-slate-400 text-sm font-semibold text-slate-800 opacity-0 transition-opacity duration-300 hover:opacity-75"                , children: "EDIT"

      })
      , _jsx('div', {
        'aria-hidden': true,
        className: "icon-wrapper absolute top-0 right-0 z-10 rounded-full bg-slate-200 px-1.5 hover:bg-slate-200"        ,
 children: 
        _jsx(EditIcon, { className: "mb-[-2px] w-3.5 pt-0.5"  ,} )
      })
    ]})
  )
}

export default EditableAvatar
